/**
 * Main Entry Point
 */

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import { LightingProvider } from './context/LightingContext'
import { App } from './App'

const root = document.getElementById('root')

if (!root) {
  throw new Error('Root element not found')
}

createRoot(root).render(
  <StrictMode>
    <HelmetProvider>
      <LightingProvider>
        <App />
      </LightingProvider>
    </HelmetProvider>
  </StrictMode>
)
